import { Suspense, lazy } from 'react'

import SuspenseLoader from './components/common/SuspenseLoader'
import AuditCreate from './views/audit/AuditCreate'
import AuditUpdate from './views/audit/AuditUpdate'
import PlanListe from './views/plan/PlanList'
import PlanCreate from './views/plan/PlanCreate'
import PlanUpdate from './views/plan/PlanUpdate'
import RisqueCreate from './views/risque/RisqueCreate'
import RisqueListe from './views/risque/RisqueListe'
import RisqueUpdate from './views/risque/RisqueUpdate'
import ProjetCreate from './views/projets/ProjetCreate'
import ProjetListe from './views/projets/ProjetList'
import ProjetUpdate from './views/projets/ProjetUpdate'
import ActionCreate from './views/action/ActionCreate'
import ActionListe from './views/action/ActionList'
import ActionUpdate from './views/action/ActionUpdate'
import ActionDetails from './views/action/ActionDetails'
import DelaiUpdate from './views/delai/DelaiUpdate'
import CoutSupplementaireUpdate from './views/CoutSupplementaire/CoutSuppUpdate'
import AuditDetail from './views/audit/AuditDetail'
import PlanDetail from './views/plan/PlanDetail'
import ProjectDetail from './views/projets/ProjectDetail'
import PipelineDetail from './views/pipeline/PipelineDetail'
import ActionListBySecurityCheckFamily from './views/action/ActionListBySecurityCheckFamily'
import MissionDetails from './views/mission/MissionDetails'
import Select from './components/common/Select'
import MissionMain from './views/mission/MissionMain'
import ProfilPage1 from './views/layouts/ProfilPage1'
import SecurityControls from './views/securityControls/SecurityControlsList'
import ExistingControlListBySecurityCheckFamily from './views/existingControl/ExistingControlListBySecurity'
import ExistingControlCreate from './views/existingControl/ExistingControlCreate'
import ExistingControlUpdate from './views/existingControl/ExistionControlUpdate'
import SubDomainListBySecurityCheckFamily from './views/subDomain/SubDomainListBySecurity'
import SubDomainListBySecurityControlAndActionId from './views/subDomain/SubDomainBySCAndTask'
import MaturiteList from './views/MaturiteMang/MaturiteList'
import MaturityDetails from './views/MaturiteMang/MaturiteDetails'
import IncidentDetail from './views/Incident/IncidentDetail'
import RisqueDetail from './views/risque/RisqueDetail'
import AddNewProjectMission from './views/projets/AddNewProjectMission'
import ProjectsByMissionId from './views/mission/ProjectsByMissionId'
import TasksByMissionId from './views/mission/TasksByMissionId'
import PlansByMissionId from './views/mission/PlansByMissionId'
import PipelinesByMissionId from './views/mission/PipelinesByMissionId'
import ExistingControl from './views/ExistingControlAnalysis/ExistingControl'
import AuditAnalysis from './views/audit/AuditAnalysis'
import IncidentAnalysis from './views/Incident/IncidentAnalysis'
import SecurityControlsAnalysis from './views/securityControls/SecurityControlsAnalysis'
import SecurityCheckFamilyAnalysis from './views/securityCheckFamily/SecurityCheckFamilyAnalysis'
import MissionIndicatorPage from './views/indicator/indicatorMission'
import ProjectIndicatorsPage from './views/indicator/indicatorProject'
import PTRIndicatorPage from './views/indicator/indicatorPTR&RISK'
import MaturityIndicatorsPage from './views/indicator/IndicatorMaturite&Conformite'
import { PriorityTasksByMissionId } from './views/mission/PriorityTasksMission'
import SelectNorm from './views/SelectNorm/SelectNorm'
import SubDomainDetails from './views/subDomain/SubDomainDetails'
import SecurityFrameWork from './views/securityFramework/SecurityFramework'
import RiskIndicatorPage from './views/indicator/indicatorRisk'
import SecurityCheckFamilyToMap from './views/RelatedControls/SecurityCheckFamilyToMap'
import ControlsToMap from './views/RelatedControls/ControlsToMap'
import RelatedDataMap from './views/RelatedControls/RelatedDataMap'
import ResetPasswordPage from './views/auth/ResetPassword'
import TeamPage from './views/team/Team'
import LicensePage from './views/license/License'
import Settings from './views/settings/Settings'
import RelatedControlsAnalysis from './views/RelatedControls/RelatedControlsAnalysis'
import NormList from './views/securityCheckFamily/NormList'
import { selectSpecifications } from './redux/specification/specificationSelectors'
import { useSelector } from 'react-redux'

const Loader = (Component: any) => (props: any) => (
  <Suspense fallback={<SuspenseLoader />}>
    <Component {...props} />
  </Suspense>
)

const MissionCreate = Loader(
  lazy(() => import('./views/mission/MissionCreate'))
)
const MissionListe = Loader(lazy(() => import('./views/mission/MissionListe')))
const MissionUpdate = Loader(
  lazy(() => import('./views/mission/MissionUpdate'))
)
const AuditListe = Loader(lazy(() => import('./views/audit/AuditList')))
const IncidentListe = Loader(
  lazy(() => import('./views/Incident/IncidentListe'))
)

const IncidentCreate = Loader(
  lazy(() => import('./views/Incident/IncidentCreate'))
)

const IncidentUpdate = Loader(
  lazy(() => import('./views/Incident/IncidentUpdate'))
)

const PipelineListe = Loader(
  lazy(() => import('./views/pipeline/PipelineListe'))
)

const PipelineUpdate = Loader(
  lazy(() => import('./views/pipeline/PipelineUpdate'))
)

const PipelineCreate = Loader(
  lazy(() => import('./views/pipeline/PipelineCreate'))
)

const routes = [
  {
    path: '/security/:selectedNorm',
    component: NormList,
  },
  {
    path: '/',
    component: MissionMain,
  },
  {
    path: '/reset-password',
    component: ResetPasswordPage,
  },
  {
    path: '/team',
    component: TeamPage,
  },
  {
    path: '/license',
    component: LicensePage,
  },
  {
    path: '/settings',
    component: Settings,
  },
  {
    path: '/select-norm',
    component: SelectNorm,
  },
  {
    path: '/maturite',
    component: MaturiteList,
  },

  {
    path: '/addmission',
    component: MissionCreate,
  },
  {
    path: 'mission/:id',
    component: MissionUpdate,
  },
  {
    path: 'existingControl/:id',
    component: ExistingControlUpdate,
  },
  {
    path: '/audits',
    component: AuditListe,
  },
  {
    path: '/addaudit',
    component: AuditCreate,
  },

  {
    path: '/addexisting/:id',
    component: ExistingControlCreate,
  },

  {
    path: 'audit/:id',
    component: AuditUpdate,
  },

  {
    path: '/incidents',
    component: IncidentListe,
  },
  {
    path: '/addincident',
    component: IncidentCreate,
  },
  {
    path: 'incident/:id',
    component: IncidentUpdate,
  },
  {
    path: 'pipeline/:id',
    component: PipelineUpdate,
  },
  {
    path: '/pipelines',
    component: PipelineListe,
  },
  {
    path: '/addpipeline',
    component: PipelineCreate,
  },
  {
    path: '/plan',
    component: PlanListe,
  },
  {
    path: '/addplan',
    component: PlanCreate,
  },
  {
    path: '/mission/:idmission/addplan',
    component: PlanCreate,
  },

  {
    path: '/plan/:id',
    component: PlanUpdate,
  },
  {
    path: '/addRisque',
    component: RisqueCreate,
  },
  {
    path: '/risques',
    component: RisqueListe,
  },
  {
    path: '/risque/:id',
    component: RisqueUpdate,
  },
  {
    path: '/addprojet',
    component: ProjetCreate,
  },
  {
    path: 'mission/:idmission/addprojet',
    component: AddNewProjectMission,
  },

  {
    path: '/mission/:idmission/pipeline/:id/addprojet',
    component: ProjetCreate,
  },

  {
    path: '/action/:actionId/securitycontrol/:securityControlId',
    component: SubDomainListBySecurityControlAndActionId,
  },

  {
    path: '/projets',
    component: ProjetListe,
  },
  {
    path: '/projet/:id',
    component: ProjetUpdate,
  },
  {
    path: '/addaction',
    component: ActionCreate,
  },
  {
    path: 'mission/:idmission/addaction',
    component: ActionCreate,
  },
  {
    path: '/actions',
    component: ActionListe,
  },

  {
    path: '/audit-detail/:id',
    component: AuditDetail,
  },
  {
    path: '/audit/view-analysis/:id',
    component: AuditAnalysis,
  },
  {
    path: '/related-controls/:selectedRelated/view-analysis/:id',
    component: RelatedControlsAnalysis,
  },

  {
    path: '/incident-detail/:id',
    component: IncidentDetail,
  },
  {
    path: '/incident/view-analysis/:id',
    component: IncidentAnalysis,
  },
  {
    path: '/risque-detail/:id',
    component: RisqueDetail,
  },
  {
    path: '/riskTreatmentPlan/view-analysis/:PlanId',
    component: PTRIndicatorPage,
  },
  {
    path: '/risque-detail/view-analysis/:id',
    component: RiskIndicatorPage,
  },
  {
    path: '/maturity/view-analysis/',
    component: MaturityIndicatorsPage,
  },

  {
    path: '/plan-detail/:id',
    component: PlanDetail,
  },
  {
    path: '/mission/:MissionId/projet/:id',
    component: ProjectDetail,
  },
  {
    path: '/project/view-analysis/:ProjetId',
    component: ProjectIndicatorsPage,
  },

  {
    path: '/mission/:idmission/projet/:idprojet/addaction',
    component: ActionCreate,
  },

  {
    path: 'mission/:MissionId/pipeline/:id',
    component: PipelineDetail,
  },

  {
    path: '/subDomain-Maturityscoring/:id',
    component: MaturityDetails,
  },

  {
    path: '/mission-details/:id',
    component: MissionDetails,
  },
  {
    path: '/mission/view-analysis/:MissionId',
    component: MissionIndicatorPage,
  },
  {
    path: '/mission-details/:id/pipelines',
    component: PipelinesByMissionId,
  },
  {
    path: '/mission-details/:id/projects',
    component: ProjectsByMissionId,
  },
  {
    path: '/mission-details/:id/tasks',
    component: TasksByMissionId,
  },
  {
    path: '/mission-details/:id/risk-treatment-plans',
    component: PlansByMissionId,
  },
  {
    path: 'select',
    component: Select,
  },

  {
    path: '/security-control-details/:id',
    component: ActionListBySecurityCheckFamily,
  },
  {
    path: '/security-control-details/view-analysis/:id',
    component: SecurityCheckFamilyAnalysis,
  },
  {
    path: '/security-controls/:SecurityId',
    component: SecurityControls,
  },
  {
    path: '/security-controls/view-analysis/:id',
    component: SecurityControlsAnalysis,
  },
  {
    path: '/mission-priority/:type/:missionId',
    component: PriorityTasksByMissionId,
  },
  {
    path: '/security-existing/:SecurityId',
    component: ExistingControlListBySecurityCheckFamily,
  },
  {
    path: 'security-controls/:securityControlId/view-existing-control/:id',
    component: ExistingControl,
  },
  {
    path: '/security-subd/:SecurityId',
    component: SubDomainListBySecurityCheckFamily,
  },
  {
    path: '/subdomain/:id',
    component: SubDomainDetails,
  },
  {
    path: '/securityFramework',
    component: SecurityFrameWork,
  },

  {
    path: `/norms/:id`,
    component: SecurityCheckFamilyToMap,
  },
  {
    path: `/relatedDataMapped/:selectedRelated/:id`,
    component: RelatedDataMap,
  },
  {
    path: `/securityControlsToMap/:id/:SecurityId`,
    component: ControlsToMap,
  },
  {
    path: '/action/:id',
    component: ActionUpdate,
  },
  {
    path: '/actiond/:id',
    component: ActionDetails,
  },

  // {
  //   path: '/diagramme',
  //   component: Scheduler,
  // } ,
  // {
  //   path: 'securtyy',
  //   component: SecurityControlsSelect
  // },

  {
    path: 'delai/:id',
    component: DelaiUpdate,
  },

  {
    path: 'missions',
    component: MissionListe,
  },

  {
    path: 'profile',
    component: ProfilPage1,
  },

  {
    path: 'coutSupplementaire/:id',
    component: CoutSupplementaireUpdate,
  },
]

export default routes
